import React from "react";
import Layout from "../Layout/Layout";
import Sidebar from "../Layout/Sidebar";

const Services = () => {
  return (
    <Layout>
      <Sidebar/>
    </Layout>
  );
};

export default Services;
